export default __webpack_public_path__ + "static/media/bvi.c3c3dd2d.jpg";